import  { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save'
import DeleteIcon from '@mui/icons-material/Delete'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary'
import { useParams } from 'react-router-dom'
import { useQuery, useMutation, useApolloClient } from '@apollo/client'
import { getStyle, getAllTags, getAllPromptsAdmin, getAllSections } from '../graphql/queries'
import { deleteStyle, updateStyle, createContent } from '../graphql/mutation'
import { uploadToS3 } from '../utils/uploadToS3'
import ImageUploadField from '../components/imageUpload';
import { designType } from '../utils/enum'
import { getMutationOptions } from '../utils/apolloHelpers'
import {
  Box,
  Typography,
  Button,
  TextField,
  Alert,
  MenuItem,
  Select,
  FormControl,
  Snackbar,
  CircularProgress,
  Autocomplete,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControlLabel,
  Radio,
  RadioGroup,
  InputLabel,
} from '@mui/material'




const toolType = [
  { value: 'IMG2IMG', name: 'IMG2IMG' },
  { value: 'IMG2VIDEO', name: 'IMG2VIDEO' },
  { value: 'IMG2VIDEO_WITH_TEXT', name: 'IMG2VIDEO_WITH_TEXT' },
  { value: 'PREDICT_WITH_MODEL', name: 'PREDICT_WITH_MODEL' },
  { value: 'TEXT2VIDEO', name: 'TEXT2VIDEO' },
  { value: 'TRAIN', name: 'TRAIN' },
  { value: 'TEXT2IMG', name: 'VIDEO2VIDEO' },
]
export default function StylePage() {
  const { id } = useParams()
  const client = useApolloClient()
  const navigate = useNavigate()

  const [style, setStyle] = useState({
    name: '',
    banner: '',
    secondBanner: '',
    createdAt: '',
    designType: '',
    gifUrl: '',
    webmUrl: '',
    webpUrl: '',
    id: '',
    rowNumber: '',
    updatedAt: '',
    videoUrl: '',
    isFuture: '',
    isPublic: false,
    tagIds: [],
    highlighted: false,
    promptIds: [],
    sectionIds: [],
  })

  const [styleData, setStyleData] = useState(null)
  const [thumbnail, setThumbnail] = useState(null)
  const [selectedThumbnail, setSelectedThumbnail] = useState(null)
  const [video, setVideo] = useState(null)
  const [selectedVideo, setSelectedVideo] = useState(null)
  const [gif, setGif] = useState(null)
  const [selectedGifUrl, setSelectedGifUrl] = useState()
  const [webmFile, setWebmFile] = useState(null)
  const [selectedWebmUrl, setSelectedWebmUrl] = useState(null)
  const [webpFile, setWebpFile] = useState(null)
  const [selectedWebpUrl, setSelectedWebpUrl] = useState(null)
  const [secondBannerFile, setSecondBannerFile] = useState(null)
  const [selectedSecondBannerUrl, setSelectedSecondBannerUrl] = useState(null)
  const [progress, setProgress] = useState(false)
  const [openImageModal, setOpenImageModal] = useState(false)
  const [modalImageSrc, setModalImageSrc] = useState('')
  const [selectedTags, setSelectedTags] = useState([])
  const [selectedSections, setSelectedSections] = useState([])

  const [snackBarOpen,setSnackBarOpen] = useState(false)
  const [snackBarMessage,setSnackBarMessge] = useState(null)
  const [snackBarSeverity, setSnackBarSeverity] = useState('success')
  const [selectedPrompts, setSelectedPrompts] = useState([])
  const [promptSearchTerm, setPromptSearchTerm] = useState('')
  const [lastAddedPromptId, setLastAddedPromptId] = useState(null)

  // Ref for the table container to manage scroll position
  const tableContainerRef = useRef(null)

  // Modal states for custom content
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedContent, setSelectedContent] = useState(null)
  const [assetChoice, setAssetChoice] = useState('default') // 'default' or 'custom'
  const [customAssets, setCustomAssets] = useState({
    banner: '',
    secondBanner: '',
    videoUrl: '',
    gifUrl: '',
    webmUrl: '',
    webpUrl: '',
    detailImage: '',
    designType: 'MEDIUM',
    rowNumber: 1
  })
  const [selectedFiles, setSelectedFiles] = useState({
    banner: null,
    secondBanner: null,
    video: null,
    gif: null,
    webm: null,
    webp: null,
    detailImage: null
  })

  const { loading, error, data, refetch } = useQuery(getStyle, {
    variables: { styleId: id },
    onCompleted: data => {
      setStyleData(data.getStyle)
    },
  })

  const { data: tagsData } = useQuery(getAllTags)
  const tags = tagsData?.getAllTags || []

  const { data: sectionsData } = useQuery(getAllSections)
  const sections = sectionsData?.getAllSections || []

  const { data: promptsData, loading: promptsLoading } = useQuery(getAllPromptsAdmin, {
    variables: { page: 1, pageSize: 1000 }
  })

  const prompts = promptsData?.getAllPromptsAdmin?.prompts || []
  
  // Filter prompts based on selected toolType and search term
  const filteredPrompts = prompts.filter(prompt => {
    const matchesToolType = !style.toolType || prompt.toolType === style.toolType
    const matchesSearch = !promptSearchTerm || 
      prompt.prompt?.toLowerCase().includes(promptSearchTerm.toLowerCase()) ||
      prompt.Style?.name?.toLowerCase().includes(promptSearchTerm.toLowerCase()) ||
      prompt.gender?.toLowerCase().includes(promptSearchTerm.toLowerCase())
    return matchesToolType && matchesSearch
  }).sort((a, b) => {
    // Show selected items first
    const aSelected = selectedPrompts.some(p => p.id === a.id)
    const bSelected = selectedPrompts.some(p => p.id === b.id)
    if (aSelected && !bSelected) return -1
    if (!aSelected && bSelected) return 1
    return 0
  })

  useEffect(() => {
    if (styleData) {
      setStyle({
        name: styleData.name,
        banner: styleData.banner || null ,
        secondBanner: styleData.secondBanner || null,
        createdAt: styleData.createdAt,
        designType: styleData.designType,
        gifUrl: styleData.gifUrl,
        webmUrl: styleData.webmUrl,
        webpUrl: styleData.webpUrl,
        aspectRatio: styleData.aspectRatio,
        rowNumber: styleData.rowNumber,
        updatedAt: styleData.updatedAt,
        videoUrl: styleData.videoUrl,
        isFuture: styleData.isFuture || false,
        isPublic: styleData.isPublic || false,
        highlighted: styleData.highlighted || false,
        tagIds: styleData.tags?.map(tag => tag.id) || [],
        toolType: styleData.toolType,
        promptIds: styleData.prompts?.map(prompt => prompt.id) || [],
        sectionIds: styleData.sections?.map(section => section.id) || [],
      })
      setSelectedGifUrl(styleData.gifUrl)
      setSelectedWebmUrl(styleData.webmUrl)
      setSelectedWebpUrl(styleData.webpUrl)
      setSelectedSecondBannerUrl(styleData.secondBanner)
      setSelectedThumbnail(styleData.banner)
      setSelectedVideo(styleData.videoUrl)
      
      // Set selected tags
      if (styleData.tags) {
        setSelectedTags(styleData.tags)
      }
      
      // Set selected sections
      if (styleData.sections) {
        setSelectedSections(styleData.sections)
      }
      
      // Set selected prompts
      if (styleData.prompts) {
        setSelectedPrompts(styleData.prompts)
      }
    }
  }, [styleData])

  // Scroll to the first unselected prompt after adding a new one
  useEffect(() => {
    if (lastAddedPromptId && tableContainerRef.current) {
      // Delay to ensure the DOM has updated and re-sorted
      setTimeout(() => {
        // Find all rows and get the first one that's not selected
        const allRows = tableContainerRef.current?.querySelectorAll('tbody tr')
        const firstUnselectedRow = Array.from(allRows || []).find(row => 
          row.getAttribute('data-selected') === 'false'
        )
        
        if (firstUnselectedRow) {
          // Get the position of the row relative to the container
          const container = tableContainerRef.current
          const containerRect = container.getBoundingClientRect()
          const rowRect = firstUnselectedRow.getBoundingClientRect()
          
          // Calculate the scroll position to place the first unselected row at the top
          // Account for the sticky header by keeping some offset
          const scrollOffset = rowRect.top - containerRect.top + container.scrollTop - 60
          
          container.scrollTo({
            top: scrollOffset,
            behavior: 'smooth'
          })
        }
        setLastAddedPromptId(null)
      }, 200)
    }
  }, [lastAddedPromptId, selectedPrompts])

  const [updateStyleMutation] = useMutation(updateStyle)
  const [deleteStyleMutation] = useMutation(deleteStyle)
  const [createContentMutation] = useMutation(createContent)

  const handleImageClick = src => {
    setModalImageSrc(src)
    setOpenImageModal(true)
  }

  const handleChange = e => {
    const { name, value } = e.target
    setStyle(prev => ({ ...prev, [name]: value }))
    
    // If toolType changes, clear selected prompts as they might not be compatible
    if (name === 'toolType') {
      setSelectedPrompts([])
      setStyle(prev => ({ ...prev, promptIds: [] }))
    }
  }
  const handleGifSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedGifUrl(URL.createObjectURL(selectedFile))
    setGif(selectedFile)
  }
  const handleVideoSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedVideo(URL.createObjectURL(selectedFile))
    setVideo(selectedFile)
  }
  const handleThumbnailSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedThumbnail(URL.createObjectURL(selectedFile))
    setThumbnail(selectedFile)
  }
  
  const handleWebmSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedWebmUrl(URL.createObjectURL(selectedFile))
    setWebmFile(selectedFile)
  }
  
  const handleWebpSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedWebpUrl(URL.createObjectURL(selectedFile))
    setWebpFile(selectedFile)
  }

  const handleSecondBannerSelected = e => {
    const selectedFile = e.target.files[0]
    setSelectedSecondBannerUrl(URL.createObjectURL(selectedFile))
    setSecondBannerFile(selectedFile)
  }
  const handleSnackBarClose=()=>{
  setSnackBarOpen(false)
}

  const handlePromptCheckboxChange = (prompt, checked) => {
    if (checked) {
      setSelectedPrompts(prev => [...prev, prompt])
      setStyle(prev => ({
        ...prev,
        promptIds: [...prev.promptIds, prompt.id]
      }))
    } else {
      setSelectedPrompts(prev => prev.filter(p => p.id !== prompt.id))
      setStyle(prev => ({
        ...prev,
        promptIds: prev.promptIds.filter(id => id !== prompt.id)
      }))
    }
  }

  // Modal handlers for custom content
  const handleAddToStyle = (prompt) => {
    setSelectedContent({ ...prompt, contentType: 'PROMPT' })
    setModalOpen(true)
    setAssetChoice('default')
    
    // Pre-populate custom assets fields with existing prompt assets
    const prefilledAssets = {
      banner: prompt.banner || '',
      secondBanner: prompt.secondBanner || '',
      videoUrl: prompt.videoUrl || '',
      gifUrl: prompt.gifUrl || '',
      webmUrl: prompt.webmUrl || '',
      webpUrl: prompt.webpUrl || '',
      detailImage: prompt.detailImage || '',
      designType: prompt.designType || 'MEDIUM',
      rowNumber: 1
    }
    
    setCustomAssets(prefilledAssets)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setSelectedContent(null)
    setAssetChoice('default')
    setCustomAssets({ banner: '', secondBanner: '', videoUrl: '', gifUrl: '', webmUrl: '', webpUrl: '', detailImage: '', designType: 'MEDIUM', rowNumber: 1 })
    setSelectedFiles({ banner: null, secondBanner: null, video: null, gif: null, webm: null, webp: null, detailImage: null })
  }

  const handleFileSelect = (type, event) => {
    const file = event.target.files[0]
    if (file) {
      setSelectedFiles(prev => ({ ...prev, [type]: file }))
    }
  }

  const handleAddWithDefault = async () => {
    if (!selectedContent) return

    try {
      // Just add to style directly (existing behavior)
      handlePromptCheckboxChange(selectedContent, true)
      setLastAddedPromptId(selectedContent.id)
      
      setSnackBarMessge(`Prompt added to style with default assets`)
      setSnackBarSeverity('success')
      setSnackBarOpen(true)
      handleCloseModal()
    } catch (error) {
      setSnackBarMessge('Failed to add prompt')
      setSnackBarSeverity('error')
      setSnackBarOpen(true)
    }
  }

  const handleAddWithCustomAssets = async () => {
    if (!selectedContent) return

    setProgress(true)
    try {
      let finalBannerUrl = customAssets.banner
      let finalSecondBannerUrl = customAssets.secondBanner
      let finalVideoUrl = customAssets.videoUrl
      let finalGifUrl = customAssets.gifUrl
      let finalWebmUrl = customAssets.webmUrl
      let finalWebpUrl = customAssets.webpUrl
      let finalDetailImageUrl = customAssets.detailImage

      // Upload banner file if selected
      if (selectedFiles.banner) {
        setSnackBarMessge('Uploading banner image...')
        setSnackBarSeverity('info')
        setSnackBarOpen(true)
        
        try {
          finalBannerUrl = await uploadToS3(selectedFiles.banner, 'img')
        } catch (uploadError) {
          throw new Error(`Failed to upload banner: ${uploadError.message}`)
        }
      }

      // Upload second banner file if selected
      if (selectedFiles.secondBanner) {
        setSnackBarMessge('Uploading second banner image...')
        setSnackBarSeverity('info')
        setSnackBarOpen(true)
        
        try {
          finalSecondBannerUrl = await uploadToS3(selectedFiles.secondBanner, 'img')
        } catch (uploadError) {
          throw new Error(`Failed to upload second banner: ${uploadError.message}`)
        }
      }

      // Upload video file if selected
      if (selectedFiles.video) {
        setSnackBarMessge('Uploading video...')
        setSnackBarSeverity('info')
        setSnackBarOpen(true)
        
        try {
          finalVideoUrl = await uploadToS3(selectedFiles.video, 'video')
        } catch (uploadError) {
          throw new Error(`Failed to upload video: ${uploadError.message}`)
        }
      }

      // Upload gif file if selected
      if (selectedFiles.gif) {
        setSnackBarMessge('Uploading gif...')
        setSnackBarSeverity('info')
        setSnackBarOpen(true)
        
        try {
          finalGifUrl = await uploadToS3(selectedFiles.gif, 'gif')
        } catch (uploadError) {
          throw new Error(`Failed to upload gif: ${uploadError.message}`)
        }
      }

      // Upload webm file if selected
      if (selectedFiles.webm) {
        setSnackBarMessge('Uploading webm video...')
        setSnackBarSeverity('info')
        setSnackBarOpen(true)
        
        try {
          finalWebmUrl = await uploadToS3(selectedFiles.webm, 'video')
        } catch (uploadError) {
          throw new Error(`Failed to upload webm: ${uploadError.message}`)
        }
      }

      // Upload webp file if selected
      if (selectedFiles.webp) {
        setSnackBarMessge('Uploading webp image...')
        setSnackBarSeverity('info')
        setSnackBarOpen(true)
        
        try {
          finalWebpUrl = await uploadToS3(selectedFiles.webp, 'img')
        } catch (uploadError) {
          throw new Error(`Failed to upload webp: ${uploadError.message}`)
        }
      }

      // Upload detail image file if selected
      if (selectedFiles.detailImage) {
        setSnackBarMessge('Uploading detail image...')
        setSnackBarSeverity('info')
        setSnackBarOpen(true)
        
        try {
          finalDetailImageUrl = await uploadToS3(selectedFiles.detailImage, 'img')
        } catch (uploadError) {
          throw new Error(`Failed to upload detail image: ${uploadError.message}`)
        }
      }

      // First create custom content
      await createContentMutation({
        variables: {
          contentId: selectedContent.id, // Use the selected content's ID (prompt)
          contentType: selectedContent.contentType, // Use the actual content type (PROMPT)
          designType: customAssets.designType,
          banner: finalBannerUrl || null,
          secondBanner: finalSecondBannerUrl || null,
          videoUrl: finalVideoUrl || null,
          gifUrl: finalGifUrl || null,
          webmUrl: finalWebmUrl || null,
          webpUrl: finalWebpUrl || null,
          detailImage: finalDetailImageUrl || null,
          rowNumber: customAssets.rowNumber,
          styleId: id // Link this content to the current style
        }
      })

      // Then add to style
      handlePromptCheckboxChange(selectedContent, true)
      setLastAddedPromptId(selectedContent.id)

      setSnackBarMessge(`Prompt added to style with custom assets`)
      setSnackBarSeverity('success')
      setSnackBarOpen(true)
      handleCloseModal()
    } catch (error) {
      setSnackBarMessge('Failed to add custom content')
      setSnackBarSeverity('error')
      setSnackBarOpen(true)
    } finally {
      setProgress(false)
    }
  }

  const handleUpdateStyle = async () => {
    setProgress(true)
    try{
    const lastGifUrl = gif ? await uploadToS3(gif, 'gif', client) : style.gifUrl || null
    const lastWebmUrl = webmFile ? await uploadToS3(webmFile, 'video', client) : style.webmUrl || null
    const lastWebpUrl = webpFile ? await uploadToS3(webpFile, 'img', client) : style.webpUrl || null
    const lastVideoUrl = video ? await uploadToS3(video, 'video', client) : style.videoUrl || null
    const thumbnailUrl = thumbnail ? await uploadToS3(thumbnail, 'img', client) : style.banner || null
    const secondBannerUrl = secondBannerFile ? await uploadToS3(secondBannerFile, 'img', client) : style.secondBanner || null
    const gpqResponse = await updateStyleMutation({
      variables: {
        styleId: id,
        name: style.name,
        banner: thumbnailUrl,
        secondBanner: secondBannerUrl,
        createdAt: style.createdAt,
        designType: style.designType,
        gifUrl: lastGifUrl,
        rowNumber: 1,
        webmUrl: lastWebmUrl,
        webpUrl: lastWebpUrl,
        isFuture: false,
        isPublic: false,
        highlighted: false,
        aspectRatio: style.aspectRatio,
        updatedAt: style.updatedAt,
        videoUrl: lastVideoUrl,
        tagIds: style.tagIds,
        toolType: style.toolType,
        promptIds: style.promptIds,
        sectionIds: style.sectionIds,
      },
      // Properly refetch all related queries
      ...getMutationOptions('STYLES', id)
    })
    if (gpqResponse.data) {
      setSnackBarMessge('Style updated successfully');
      setSnackBarSeverity('success');
      setSnackBarOpen(true);
      // Navigation with delay to show success message
      setTimeout(() => {
        navigate('/styles', { 
          state: { 
            refreshData: true,
            updatedItemId: id 
          }
        });
      }, 1000);
    } else {
      setSnackBarMessge('Update failed')
      setSnackBarSeverity('error')
      setSnackBarOpen(true)
    } 
  } catch(error) {
      console.error('Error updating prompt:', error);
      setSnackBarMessge(`update failed: ${error.message}`);
      setSnackBarSeverity('error');
      setSnackBarOpen(true);
  } finally {
      setProgress(false);
    }
  }


  const handleDeleteStyle = async () => {
    try{
    const gpqResponse = await deleteStyleMutation({
      variables: {
        styleId: id,
      },
    })
    if (gpqResponse.data) {
      setSnackBarMessge('Style deleted successfully');
      setSnackBarSeverity('success');
      setSnackBarOpen(true);
      setTimeout(() => {
        navigate('/styles');
      }, 1000);
    } else {
      setSnackBarMessge('Delete failed: No data returned');
      setSnackBarSeverity('error');
      setSnackBarOpen(true);
      throw new Error('No data returned from delete style');
    }
} catch (error){
      console.error("Delete error:", error);
      setSnackBarMessge(`Delete failed: ${error.message}`);
      setSnackBarSeverity('error');
      setSnackBarOpen(true);
    }
  }

  return (
    <Box>
      <Snackbar
      open={snackBarOpen}
      autoHideDuration={3000}
      onClose={handleSnackBarClose}
      message={snackBarMessage}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert 
          onClose={handleSnackBarClose} 
          severity={snackBarSeverity} 
          sx={{ width: '100%' }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>

            {/* Sticky Header with Actions */}
      <Box 
        sx={{ 
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          backgroundColor: 'white',
          borderBottom: '1px solid #e9ecef',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 4, flexWrap: 'wrap', gap: 2 }}>
          <Typography variant='h4' sx={{color:'#212529',fontWeight:'bold' }}>
            Style Details
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Button
              onClick={handleDeleteStyle}
              variant="outlined"
              color="error"
              startIcon={<DeleteIcon />}
              sx={{ 
                borderRadius: 2,
                px: 3,
                '&:hover': { 
                  backgroundColor: '#e74c3c', 
                  color: 'white',
                  borderColor: '#e74c3c'
                }
              }}
            >
              Delete Style
            </Button>
            <Button
              onClick={handleUpdateStyle}
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              sx={{ 
                borderRadius: 2,
                px: 4,
                backgroundColor: '#3498db',
                '&:hover': { backgroundColor: '#2980b9' }
              }}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </Box>
      {progress && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255,255,255,0.7)',
            zIndex: 1300,
          }}
        >
          <CircularProgress size={80} thickness={5} />
        </Box>
      )}
        
    {/* Main Content Container */}
    <Box sx={{ maxWidth: '1400px', mx: 'auto', px: { xs: 2, md: 4 } }}>
      {/* Basic Information Section */}
      <Paper sx={{ p: 4, mb: 4, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#2c3e50', borderBottom: '2px solid #3498db', pb: 1 }}>
          Basic Information
        </Typography>
        
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            label="Style Name"
            variant="outlined"
            name="name"
            value={style?.name ?? ''}
            onChange={handleChange}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
          <FormControl fullWidth>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#34495e' }}>Design Type</Typography>
            <Select 
              name="designType" 
              onChange={handleChange} 
              value={style?.designType ?? ''}
              sx={{ borderRadius: 2 }}
            >
              {designType.map(i => (
                <MenuItem key={i.name} value={i.name}>
                  {i.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <FormControl fullWidth>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#34495e' }}>Tool Type</Typography>
            <Select 
              name="toolType" 
              onChange={handleChange} 
              value={style?.toolType ?? ''}
              sx={{ borderRadius: 2 }}
            >
              {toolType.map(i => (
                <MenuItem key={i.name} value={i.name}>
                  {i.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Paper>

      {/* Settings Section */}
      <Paper sx={{ p: 4, mb: 4, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#2c3e50', borderBottom: '2px solid #e74c3c', pb: 1 }}>
          Settings & Configuration
        </Typography>
        

              {/* Tags Selection */}
        <Box>
          <Typography variant="body2" sx={{ mb: 2, fontWeight: 500, color: '#34495e' }}>Tags</Typography>
          <Autocomplete
            multiple
            options={tags}
            getOptionLabel={(option) => option.name}
            value={selectedTags}
            onChange={(event, newValue) => {
              setSelectedTags(newValue)
              setStyle(prev => ({
                ...prev,
                tagIds: newValue.map(tag => tag.id)
              }))
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select tags..."
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
              />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={option.id}
                  label={option.name}
                  size="small"
                  sx={{ 
                    backgroundColor: '#3498db', 
                    color: 'white',
                    '& .MuiChip-deleteIcon': { color: 'white' }
                  }}
                />
              ))
            }
          />
          </Box>

          {/* Sections Selection */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="body2" sx={{ mb: 2, fontWeight: 500, color: '#34495e' }}>Sections</Typography>
            <Autocomplete
              multiple
              options={sections}
              getOptionLabel={(option) => option.name}
              value={selectedSections}
              onChange={(event, newValue) => {
                setSelectedSections(newValue)
                setStyle(prev => ({
                  ...prev,
                  sectionIds: newValue.map(section => section.id)
                }))
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select sections..."
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                />
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    {...getTagProps({ index })}
                    key={option.id}
                    label={option.name}
                    size="small"
                    sx={{ 
                      backgroundColor: '#27ae60', 
                      color: 'white',
                      '& .MuiChip-deleteIcon': { color: 'white' }
                    }}
                  />
                ))
              }
            />
          </Box>
      </Paper>

      {/* Media Section */}
      <Paper sx={{ p: 4, mb: 4, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#2c3e50', borderBottom: '2px solid #9b59b6', pb: 1 }}>
          Media Assets
        </Typography>
        
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr' }, gap: 4 }}>
          <Box>
          <ImageUploadField
          label="Thumbnail"
          file={thumbnail}
          imageUrl={selectedThumbnail ?? style?.banner}
          inputName="thumbnail"
          onImageChange={handleThumbnailSelected}
          onImageClick={handleImageClick}
          onDelete={() => {
            setSelectedThumbnail(null);
            setStyle(prev => ({ ...prev, banner: null }));
          }}
        />
          </Box>

          <Box>
        <ImageUploadField
        label="Video"
        file={video}
        imageUrl={selectedVideo ?? style?.videoUrl}
        inputName="video"
        isVideo
        onImageChange={handleVideoSelected}
        onImageClick={handleImageClick}
        onDelete={() => {
          setSelectedVideo(null);
          setStyle(prev => ({ ...prev, videoUrl: null }));
        }}
      />
          </Box>

          <Box>
        <ImageUploadField
              label="GIF"
        file={gif}
        imageUrl={selectedGifUrl ?? style?.gifUrl}
        inputName="gif"
        onImageChange={handleGifSelected}
        onImageClick={handleImageClick}
        onDelete={() => {
          setSelectedGifUrl(null);
          setStyle(prev => ({ ...prev, gifUrl: null }));
        }}
        isVideo
      />
      </Box>
        </Box>
        
        {/* Additional Media Assets Row */}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr' }, gap: 4, mt: 4 }}>
          <Box>
            <ImageUploadField
              label="WEBM Video"
              file={webmFile}
              imageUrl={selectedWebmUrl ?? style?.webmUrl}
              inputName="webm"
              isVideo
              onImageChange={handleWebmSelected}
              onImageClick={handleImageClick}
              onDelete={() => {
                setSelectedWebmUrl(null);
                setWebmFile(null);
                setStyle(prev => ({ ...prev, webmUrl: null }));
              }}
            />
          </Box>
          
          <Box>
            <ImageUploadField
              label="WEBP Image"
              file={webpFile}
              imageUrl={selectedWebpUrl ?? style?.webpUrl}
              inputName="webp"
              onImageChange={handleWebpSelected}
              onImageClick={handleImageClick}
              onDelete={() => {
                setSelectedWebpUrl(null);
                setWebpFile(null);
                setStyle(prev => ({ ...prev, webpUrl: null }));
              }}
            />
          </Box>

          <Box>
            <ImageUploadField
              label="Second Banner"
              file={secondBannerFile}
              imageUrl={selectedSecondBannerUrl ?? style?.secondBanner}
              inputName="secondBanner"
              onImageChange={handleSecondBannerSelected}
              onImageClick={handleImageClick}
              onDelete={() => {
                setSelectedSecondBannerUrl(null);
                setSecondBannerFile(null);
                setStyle(prev => ({ ...prev, secondBanner: null }));
              }}
            />
          </Box>
        </Box>
      </Paper>
    </Box>
{openImageModal && (
  <Box
    onClick={() => setOpenImageModal(false)}
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.7)',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <img
      src={modalImageSrc}
      alt="Full Preview"
      style={{
        maxWidth: '90%',
        maxHeight: '90%',
        objectFit: 'contain',
        borderRadius: '10px',
      }}
      onClick={e => e.stopPropagation()} 
    />
  </Box>
)}


      {/* Prompts Selection Section */}
      {style.toolType && (
        <Box sx={{ maxWidth: '1400px', mx: 'auto', px: { xs: 2, md: 4 }, mb: 4 }}>
          <Paper sx={{ p: 4, borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#2c3e50', borderBottom: '2px solid #f39c12', pb: 1 }}>
              Associated Prompts ({style.toolType})
            </Typography>

            {/* Selected Prompts Display */}
            {selectedPrompts.length > 0 && (
              <Box sx={{ mb: 4, p: 3, backgroundColor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600, color: '#2c3e50' }}>
                  Selected Prompts ({selectedPrompts.length})
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
                  {selectedPrompts.map((prompt) => (
                    <Chip
                      key={prompt.id}
                      label={prompt.name || (prompt.prompt?.length > 40 ? prompt.prompt.substring(0, 40) + '...' : prompt.prompt)}
                      onDelete={() => handlePromptCheckboxChange(prompt, false)}
                      variant="filled"
                      size="medium"
                      sx={{ 
                        backgroundColor: '#f39c12', 
                        color: 'white',
                        fontWeight: 500,
                        '& .MuiChip-deleteIcon': { 
                          color: 'white',
                          '&:hover': { color: '#ecf0f1' }
                        }
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
            
            {/* Prompts Search Bar */}
            <TextField
              fullWidth
              placeholder="Search prompts by text, style, or gender..."
              value={promptSearchTerm}
              onChange={(e) => setPromptSearchTerm(e.target.value)}
              sx={{ 
                mb: 3,
                '& .MuiOutlinedInput-root': { 
                  borderRadius: 2,
                  backgroundColor: '#f8f9fa'
                }
              }}
              InputProps={{
                sx: { fontSize: '0.95rem' }
              }}
            />
            
            <TableContainer 
              ref={tableContainerRef}
              component={Paper} 
              sx={{ 
                maxHeight: 500, 
                borderRadius: 2,
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                border: '1px solid #e9ecef'
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600, width: 50 }}>
                      {/* Checkbox column */}
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}>
                      Banner
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}>
                      Prompt
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}>
                      Style
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}>
                      Gender
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8f9fa', fontWeight: 600 }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {promptsLoading ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                        <CircularProgress size={30} sx={{ color: '#3498db' }} />
                        <Typography variant="body2" sx={{ mt: 2, color: '#7f8c8d' }}>
                          Loading prompts...
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : filteredPrompts.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                        <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 500 }}>
                          {style.toolType ? `No prompts found for ${style.toolType}` : 'Select a tool type to see available prompts'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredPrompts.map((prompt) => {
                      const isSelected = selectedPrompts.some(p => p.id === prompt.id)
                      return (
                        <TableRow 
                          key={prompt.id} 
                          hover 
                          data-selected={isSelected}
                          sx={{ 
                            '&:hover': { backgroundColor: '#f8f9fa' },
                            backgroundColor: isSelected ? '#e3f2fd' : 'inherit'
                          }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isSelected}
                              onChange={(e) => handlePromptCheckboxChange(prompt, e.target.checked)}
                              sx={{
                                color: '#3498db',
                                '&.Mui-checked': {
                                  color: '#3498db',
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            {prompt.banner ? (
                              <Box
                                component="img"
                                src={prompt.banner}
                                alt="Prompt banner"
                                sx={{
                                  width: 50,
                                  height: 50,
                                  borderRadius: 2,
                                  objectFit: 'cover',
                                  border: '1px solid #e9ecef',
                                  cursor: 'pointer',
                                  '&:hover': { transform: 'scale(1.05)' },
                                  transition: 'transform 0.2s ease'
                                }}
                                onClick={() => handleImageClick(prompt.banner)}
                              />
                            ) : (
                              <Box
                                sx={{
                                  width: 50,
                                  height: 50,
                                  backgroundColor: '#f5f5f5',
                                  borderRadius: 2,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: '1px solid #e9ecef',
                                }}
                              >
                                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                                  No Image
                                </Typography>
                              </Box>
                            )}
                          </TableCell>
                          <TableCell sx={{ maxWidth: 250 }}>
                            <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
                              {prompt.prompt?.length > 80 ? prompt.prompt.substring(0, 80) + '...' : prompt.prompt}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 500, color: '#2c3e50' }}>
                              {prompt.Style?.name || 'No Style'}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Chip 
                              label={prompt.gender || 'N/A'} 
                              size="small"
          variant="outlined"
                              sx={{ 
                                borderColor: '#3498db',
                                color: '#3498db',
                                fontWeight: 500
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              {isSelected && (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="error"
                                  onClick={() => handlePromptCheckboxChange(prompt, false)}
                                >
                                  Remove
                                </Button>
                              )}
                              {!isSelected && (
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => handleAddToStyle(prompt)}
                                  sx={{ 
                                    backgroundColor: '#3498db',
                                    '&:hover': { backgroundColor: '#2980b9' }
                                  }}
                                >
                                  Add to Style
                                </Button>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      )
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
      </Box>
      )}

      {/* Custom Content Modal */}
      <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle>
          Add Prompt to Style
        </DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            {selectedContent && (
              <Box sx={{ mb: 3, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" gutterBottom>
                  Prompt: {selectedContent.name || 'Untitled'}
                </Typography>
                {selectedContent.banner && (
                  <img
                    src={selectedContent.banner}
                    alt="Prompt preview"
                    style={{
                      width: '100px',
                      height: '100px',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      marginTop: '8px'
                    }}
                  />
                )}
                <Typography variant="body2" sx={{ mt: 1, maxWidth: '400px' }}>
                  {selectedContent.prompt}
                </Typography>
              </Box>
            )}

            <Typography variant="h6" gutterBottom>
              Choose Asset Option:
            </Typography>
            
            <RadioGroup
              value={assetChoice}
              onChange={(e) => setAssetChoice(e.target.value)}
            >
              <FormControlLabel
                value="default"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body1" fontWeight="bold">
                      Use Default Assets
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Use the original banner, video, and design type from the prompt
                    </Typography>
                  </Box>
                }
              />
              <FormControlLabel
                value="custom"
                control={<Radio />}
                label={
                  <Box>
                    <Typography variant="body1" fontWeight="bold">
                      Add Custom Assets
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Override the default assets with custom banner, video, and design type for this style
                    </Typography>
                  </Box>
                }
              />
            </RadioGroup>

            {assetChoice === 'custom' && (
              <Box sx={{ mt: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                <Typography variant="h6" gutterBottom>
                  Custom Assets
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" gutterBottom>
                      Banner Image:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'flex-end' }}>
                      <TextField
                        label="Banner URL"
                        value={customAssets.banner}
                        onChange={(e) => setCustomAssets(prev => ({ ...prev, banner: e.target.value }))}
                        placeholder="https://example.com/banner.jpg"
                        sx={{ flex: 1 }}
                      />
                      <Typography variant="body2" color="text.secondary" sx={{ mx: 1, mb: 1 }}>
                        OR
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="banner-upload-style"
                          type="file"
                          onChange={(e) => handleFileSelect('banner', e)}
                        />
                        <label htmlFor="banner-upload-style">
                          <Button
                            variant="outlined"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            size="small"
                          >
                            Choose Image
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    
                    {selectedFiles.banner && (
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                        Selected: {selectedFiles.banner.name}
                      </Typography>
                    )}
                  </Grid>
                  
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" gutterBottom>
                      Second Banner:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'flex-end' }}>
                      <TextField
                        label="Second Banner URL"
                        value={customAssets.secondBanner}
                        onChange={(e) => setCustomAssets(prev => ({ ...prev, secondBanner: e.target.value }))}
                        placeholder="https://example.com/second-banner.jpg"
                        sx={{ flex: 1 }}
                      />
                      <Typography variant="body2" color="text.secondary" sx={{ mx: 1, mb: 1 }}>
                        OR
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="second-banner-upload-style"
                          type="file"
                          onChange={(e) => handleFileSelect('secondBanner', e)}
                        />
                        <label htmlFor="second-banner-upload-style">
                          <Button
                            variant="outlined"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            size="small"
                          >
                            Choose Image
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    
                    {selectedFiles.secondBanner && (
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                        Selected: {selectedFiles.secondBanner.name}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2" gutterBottom>
                      Video:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'flex-end' }}>
                      <TextField
                        label="Video URL"
                        value={customAssets.videoUrl}
                        onChange={(e) => setCustomAssets(prev => ({ ...prev, videoUrl: e.target.value }))}
                        placeholder="https://example.com/video.mp4"
                        sx={{ flex: 1 }}
                      />
                      <Typography variant="body2" color="text.secondary" sx={{ mx: 1, mb: 1 }}>
                        OR
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <input
                          accept="video/*"
                          style={{ display: 'none' }}
                          id="video-upload-style"
                          type="file"
                          onChange={(e) => handleFileSelect('video', e)}
                        />
                        <label htmlFor="video-upload-style">
                          <Button
                            variant="outlined"
                            component="span"
                            startIcon={<VideoLibraryIcon />}
                            size="small"
                          >
                            Choose Video
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    
                    {selectedFiles.video && (
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                        Selected: {selectedFiles.video.name}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2" gutterBottom>
                      GIF:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'flex-end' }}>
                      <TextField
                        label="GIF URL"
                        value={customAssets.gifUrl}
                        onChange={(e) => setCustomAssets(prev => ({ ...prev, gifUrl: e.target.value }))}
                        placeholder="https://example.com/animation.gif"
                        sx={{ flex: 1 }}
                      />
                      <Typography variant="body2" color="text.secondary" sx={{ mx: 1, mb: 1 }}>
                        OR
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <input
                          accept="image/gif"
                          style={{ display: 'none' }}
                          id="gif-upload-style"
                          type="file"
                          onChange={(e) => handleFileSelect('gif', e)}
                        />
                        <label htmlFor="gif-upload-style">
                          <Button
                            variant="outlined"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            size="small"
                          >
                            Choose GIF
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    
                    {selectedFiles.gif && (
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                        Selected: {selectedFiles.gif.name}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2" gutterBottom>
                      WEBM Video:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'flex-end' }}>
                      <TextField
                        label="WEBM URL"
                        value={customAssets.webmUrl}
                        onChange={(e) => setCustomAssets(prev => ({ ...prev, webmUrl: e.target.value }))}
                        placeholder="https://example.com/video.webm"
                        sx={{ flex: 1 }}
                      />
                      <Typography variant="body2" color="text.secondary" sx={{ mx: 1, mb: 1 }}>
                        OR
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <input
                          accept="video/webm"
                          style={{ display: 'none' }}
                          id="webm-upload-style"
                          type="file"
                          onChange={(e) => handleFileSelect('webm', e)}
                        />
                        <label htmlFor="webm-upload-style">
                          <Button
                            variant="outlined"
                            component="span"
                            startIcon={<VideoLibraryIcon />}
                            size="small"
                          >
                            Choose WEBM
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    
                    {selectedFiles.webm && (
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                        Selected: {selectedFiles.webm.name}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2" gutterBottom>
                      WEBP Image:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'flex-end' }}>
                      <TextField
                        label="WEBP URL"
                        value={customAssets.webpUrl}
                        onChange={(e) => setCustomAssets(prev => ({ ...prev, webpUrl: e.target.value }))}
                        placeholder="https://example.com/image.webp"
                        sx={{ flex: 1 }}
                      />
                      <Typography variant="body2" color="text.secondary" sx={{ mx: 1, mb: 1 }}>
                        OR
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <input
                          accept="image/webp"
                          style={{ display: 'none' }}
                          id="webp-upload-style"
                          type="file"
                          onChange={(e) => handleFileSelect('webp', e)}
                        />
                        <label htmlFor="webp-upload-style">
                          <Button
                            variant="outlined"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            size="small"
                          >
                            Choose WEBP
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    
                    {selectedFiles.webp && (
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                        Selected: {selectedFiles.webp.name}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="subtitle2" gutterBottom>
                      Detail Image:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'flex-end' }}>
                      <TextField
                        label="Detail Image URL"
                        value={customAssets.detailImage}
                        onChange={(e) => setCustomAssets(prev => ({ ...prev, detailImage: e.target.value }))}
                        placeholder="https://example.com/detail-image.jpg"
                        sx={{ flex: 1 }}
                      />
                      <Typography variant="body2" color="text.secondary" sx={{ mx: 1, mb: 1 }}>
                        OR
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="detail-image-upload-style"
                          type="file"
                          onChange={(e) => handleFileSelect('detailImage', e)}
                        />
                        <label htmlFor="detail-image-upload-style">
                          <Button
                            variant="outlined"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            size="small"
                          >
                            Choose Image
                          </Button>
                        </label>
                      </Box>
                    </Box>
                    
                    {selectedFiles.detailImage && (
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                        Selected: {selectedFiles.detailImage.name}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel>Design Type</InputLabel>
                      <Select
                        value={customAssets.designType}
                        label="Design Type"
                        onChange={(e) => setCustomAssets(prev => ({ ...prev, designType: e.target.value }))}
                      >
                        {designType.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Row Number"
                      type="number"
                      value={customAssets.rowNumber}
                      onChange={(e) => setCustomAssets(prev => ({ ...prev, rowNumber: parseInt(e.target.value) || 1 }))}
                      placeholder="1"
                      fullWidth
                      helperText="Order position for this content item"
                      inputProps={{ min: 1 }}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={assetChoice === 'default' ? handleAddWithDefault : handleAddWithCustomAssets}
            disabled={progress}
            sx={{ 
              backgroundColor: '#3498db',
              '&:hover': { backgroundColor: '#2980b9' }
            }}
          >
            {progress ? <CircularProgress size={20} /> : `Add ${assetChoice === 'default' ? 'with Default' : 'with Custom'} Assets`}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  )
}
